module.exports = __webpack_public_path__ + "static/media/storeIcon.aba6bc59.svg";